import { MEETING_FILTERS } from '@kaiku/shared'
import React from 'react'

import Meetings from './Meetings'

const RequestedMeetings = () => <Meetings filter={MEETING_FILTERS.meetingRequested} />
export default RequestedMeetings
